import { type IAudit, findOneById } from '@ifs-gcp/core';
import type { ReportWidgetChild } from '@ifs-gcp/core/models';

export function syncReportLanguage(
  audit: IAudit,
  checklistContext: string[],
  language: string,
): void {
  const reportTemplateElement = findOneById<ReportWidgetChild>(
    // Needs to target rawTemplate, because report widget is not visible for non-admin users, despite being available for generation
    audit.templateHandler.rawTemplate,
    'widgetReport',
    checklistContext[0],
  );

  if (!reportTemplateElement) {
    return;
  }

  const { supportedLanguages = [] } = reportTemplateElement.props;

  const reportNode = audit.templateHandler.toNode(reportTemplateElement);

  const reportDomain = audit.factory('report', reportNode);

  reportDomain.language = supportedLanguages.includes(language) ? language : supportedLanguages[0];

  reportNode.destroy();
}
